import { GambleCollectCommand } from "slotworks/commands/comms/gamble-collect-command";
import { GambleInitCommand } from "slotworks/commands/comms/gamble-init-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import Contract from "slotworks/utils/contracts/contract";
import WinCycle from "./win-cycle";

export default class WinCycleGamble extends WinCycle {
    private record?: Record;

    public onEnter() {
        this.signalBindings.push(Components.gamble.onGambleStart.add(() => this.onGambleStart()));
        this.signalBindings.push(Components.gamble.onGambleCollect.add(() => this.onGambleCollect()));

        const gameplay = GameState.getCurrentGame();
        this.record = gameplay.getCurrentRecord();
        if (this.record instanceof SpinRecord) {
            if (this.record.gamble) {
                SmartUIFlags.set(SmartUIFlag.GAMBLE, true);
            }
        }

        super.onEnter();
    }

    public onSkip() {
        if (this.record && this.record.gamble) {
            SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
            this.collect().then(() => super.onSkip());
        } else {
            super.onSkip();
        }
    }

    public onExit() {
        if (this.record && this.record.gamble) {
            SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
        }

        super.onExit();
    }

    protected onGambleStart(): void {
        if (this.record && this.record instanceof SpinRecord) {
            GambleInitCommand().then(() => {
                this.record = GameState.getCurrentGame().nextRecord();
                this.collapse();
            });
        } else {
            this.collapse();
        }
    }

    protected onGambleCollect(): void {
        SmartUIFlags.set(SmartUIFlag.GAMBLE, false);
        this.collect().execute();
    }

    protected collect(): Contract<void> {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);
        return new Contract<void>((resolve) => {
            GambleCollectCommand().then(() => {
                SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
                this.record.gamble = false;

                resolve();
            });
        });
    }
}
